import { MerchantAccountSettingTrackingPoint } from '@shopee-user/tracking-constants';

import { PageType } from '../constants';

const MerchantAccountSettingTrackingSchema: Record<
  MerchantAccountSettingTrackingPoint,
  string
> = {
  [MerchantAccountSettingTrackingPoint.PageView]: '',
  [MerchantAccountSettingTrackingPoint.BackButtonClick]: '',
  [MerchantAccountSettingTrackingPoint.MyAccountButtonClick]: '',
  [MerchantAccountSettingTrackingPoint.MyStaffAccountButtonClick]: '',
  [MerchantAccountSettingTrackingPoint.LogoutPopupImpression]: '',
  [MerchantAccountSettingTrackingPoint.LogoutButtonClick]: '',
  [MerchantAccountSettingTrackingPoint.LogoutPopupConfirmButtonClick]: '',
  [MerchantAccountSettingTrackingPoint.LogoutPopupCancelButtonClick]: '',
};

export const getMerchantAccountSettingPageTypeAndSchema = (
  trackingPoint: MerchantAccountSettingTrackingPoint
) => {
  return {
    page_type: PageType.MerchantAccountSettingPage,
    schema: MerchantAccountSettingTrackingSchema[trackingPoint],
  };
};
